import React, { Suspense } from 'react';
import Loading from '@/components/Loading';
import { useSelector } from "react-redux";

// 将返回的函数转换为真正的组件
const LazySuspenseComponent = (Component, extraProps) => {
  // 这是一个真正的 React 组件
  const WrappedComponent = (props) => {
    const { themeStatus } = useSelector((state) => state.contentCheck);

    return (
      <Suspense
        fallback={
          <div className={`${
              themeStatus === "sun"
                ? "fullpage-loading-wrap"
                : "fullpage-loading-wrap-drak"
            }`} >
            <Loading />
          </div>
        }
      >
        <Component {...extraProps} {...props} />
      </Suspense>
    );
  };
  
  // 为组件添加显示名称，便于调试
  WrappedComponent.displayName = `LazySuspense(${Component.displayName || Component.name || 'Component'})`;
  
  return WrappedComponent;
};

export default LazySuspenseComponent;
